<template>
  <div class="flex gap-2">
    <!-- <VaIconMenuCollapsed
      class="cursor-pointer"
      :class="{ 'x-flip': !isSidebarMinimized }"
      :color="collapseIconColor"
      @click="isSidebarMinimized = !isSidebarMinimized"
    /> -->

    <!-- <VaButton
      preset="secondary"
      class="sidebar-toggle-btn"
      :class="isSidebarMinimized ? 'icon-flipped' : ''"
      icon="menu_open"
      :aria-label="isSidebarMinimized ? 'Open sidebar' : 'Close sidebar'"
      color="secondary"
      size="medium"
      @click="isSidebarMinimized = !isSidebarMinimized"
    /> -->

    <nav class="flex items-center">
      <VaBreadcrumbs>
        <VaBreadcrumbsItem
          v-for="(item, index) in breadcrumbItems"
          :key="`${item.routeName}-${index}`"
          :label="item.label"
          :to="!item.isActive ? { name: item.routeName } : undefined"
          @click="handleBreadcrumbClick(item)"
        />
      </VaBreadcrumbs>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
// import { useColors } from 'vuestic-ui'
// import VaIconMenuCollapsed from '../icons/VaIconMenuCollapsed.vue'
// import { storeToRefs } from 'pinia'
// import { useGlobalStore } from '../../stores/global-store'

// const { isSidebarMinimized } = storeToRefs(useGlobalStore())

const router = useRouter()
const route = useRoute()

type BreadcrumbItem = {
  label: string
  routeName: string
  isActive: boolean
}

// Build breadcrumb trail based on route metadata and parent relationships
const buildBreadcrumbTrail = (currentRoute: any): BreadcrumbItem[] => {
  const trail: BreadcrumbItem[] = []

  // Helper function to find route by name
  const findRouteByName = (name: string) => {
    const findInRoutes = (routes: any[]): any => {
      for (const route of routes) {
        if (route.name === name) {
          return route
        }
        if (route.children) {
          const found = findInRoutes(route.children)
          if (found) return found
        }
      }
      return null
    }
    return findInRoutes(router.getRoutes())
  }

  // Build trail recursively by following parent routes
  const buildTrail = (routeName: string) => {
    const routeRecord = findRouteByName(routeName)
    if (!routeRecord || !routeRecord.meta?.breadcrumb) return

    // If this route has a parent, build trail for parent first
    if (routeRecord.meta.parentRoute) {
      buildTrail(routeRecord.meta.parentRoute)
    }

    // Add current route to trail
    let breadcrumbLabel = routeRecord.meta.breadcrumb

    // Special handling for member details to show member name
    if (routeName === 'member-detail' && currentRoute.meta?.memberName) {
      breadcrumbLabel = currentRoute.meta.memberName
    }

    trail.push({
      label: breadcrumbLabel,
      routeName: routeName,
      isActive: routeName === currentRoute.name,
    })
  }

  // Start building trail from current route
  if (currentRoute.name) {
    buildTrail(currentRoute.name as string)
  }

  return trail
}

const breadcrumbItems = computed(() => {
  return buildBreadcrumbTrail(route)
})

// const { getColor } = useColors()
// const collapseIconColor = computed(() => getColor('secondary'))

const handleBreadcrumbClick = (item: BreadcrumbItem) => {
  if (!item.isActive) {
    router.push({ name: item.routeName })
  }
}
</script>

<style lang="scss" scoped>
.x-flip {
  transform: scaleX(-100%);
}
:deep(.icon-flipped .va-icon) {
  transform: scaleX(-1);
}
</style>
